import { render, staticRenderFns } from "./ListUltimasReservas.vue?vue&type=template&id=69a69540&"
import script from "./ListUltimasReservas.vue?vue&type=script&lang=js&"
export * from "./ListUltimasReservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports